module.exports = __webpack_public_path__ + "img/app-footer.28d5c575.png";